export const allowedFrameAttributes = new Set([
    'className',
    'title',
    'height',
    'width',
    'scrolling',
    'allow',
    'sandbox',
] as const);

type AttributesIterator = ReturnType<(typeof allowedFrameAttributes)['values']>;

export type AllowedFrameAttribute = AttributesIterator extends Iterator<infer T> ? T : never;

export const isAllowedFrameAttribute = (key: string): key is AllowedFrameAttribute =>
    allowedFrameAttributes.has(key as AllowedFrameAttribute);

export type FrameAttributes = {
    [KEY in AllowedFrameAttribute]?: string;
};
